import { useState } from 'react';

/**
 * Floating "Demo Mode" pill shown only when REACT_APP_DEMO_MODE === 'true'.
 * Clicking it reveals a small panel with a "Reset demo data" button that
 * clears the MSW-backed store + auth tokens and reloads.
 *
 * Deliberately simple — no design-system imports so it works even if the
 * demo build has cosmetic mismatches in some deep component. This is the
 * salesperson's escape hatch.
 */
const DemoBanner = () => {
  const [open, setOpen] = useState(false);

  const isDemo = process.env.REACT_APP_DEMO_MODE === 'true';
  if (!isDemo) return null;

  const handleReset = async () => {
    if (!confirm('Resetar dados de demonstração? Qualquer alteração feita nesta sessão será perdida.')) return;
    try {
      const module = await import('@cobliteam/msw-demo');
      if (module.resetDemo && typeof module.resetDemo === 'function') {
        module.resetDemo();
      } else {
        throw new Error('resetDemo function not found in @cobliteam/msw-demo');
      }
    } catch (err) {
      const message = 'Erro ao resetar dados do demo';
      console.error(message, err);
      alert(message);
    }
  };

  const baseStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: 16,
    right: 16,
    zIndex: 99999,
    fontFamily: 'system-ui, sans-serif',
  };

  return (
    <div style={baseStyle}>
      <button
        type='button'
        onClick={() => setOpen((o) => !o)}
        style={{
          background: '#7a3df5',
          color: '#fff',
          border: 'none',
          borderRadius: 999,
          padding: '6px 12px',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        DEMO MODE
      </button>
      {open && (
        <div
          style={{
            position: 'absolute',
            bottom: 36,
            right: 0,
            background: '#fff',
            border: '1px solid #e5e5e5',
            borderRadius: 8,
            padding: 12,
            minWidth: 220,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          }}
        >
          <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>Todos os dados são fictícios e processados localmente.</div>
          <button
            type='button'
            onClick={handleReset}
            style={{
              width: '100%',
              background: '#f5f5f5',
              color: '#222',
              border: '1px solid #ddd',
              borderRadius: 6,
              padding: '8px 10px',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Resetar dados do demo
          </button>
        </div>
      )}
    </div>
  );
};

export default DemoBanner;